var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label)+":")]):_vm._e(),_c('span',{class:{ 'grey--text': !_vm.money }},[_vm._v(" "+_vm._s(!!_vm.money ? _vm.withStoreCurrency(_vm.money, _vm.multiplier) : 'N/A')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }